import axios from "axios";

const axiosInstance = axios.create({
  // baseURL: "https://vhtrackingbackend.visionarytechsolution.com/",
  baseURL: "https://admin.vhtracking.com/",
  // baseURL: "http://127.0.0.1:8000/",
});

export default axiosInstance;
